import { WithRequired } from '@csp/csp-common-model';
import { AnonymousInstructionsContentModel } from '../generated/types/AnonymousInstructionsContentModel';

type AnonymousIntructionsMockTexts = {
  welcomeTitle: string;
  welcomeBody: string;
  patientInstruction: string;
  appNameLabel: string;
  appNameText: string;
  appSponsorText: string;
  patientInstallationInstruction: string;
  patientLoginDetailsHeader: string;
  scanCredentialsBody: string;
  usernameLabel: string;
  temporaryPasswordLabel: string;
  temporaryPasswordValidDateLabel: string;
  supportDetailsHeader: string;
  supportDetailsBody: string;
  supportNumberLabel: string;
  patientIdentfierLabel: string;
  patient_web_instructions: string;
};

const create = (
  partial?: Partial<AnonymousIntructionsMockTexts>,
): WithRequired<AnonymousInstructionsContentModel, 'pdf'> => ({
  metadata: {},
  title: '[M]title',
  version: 'V1',
  pdf: {
    metadata: {},
    welcome_message: {
      welcome_message:
        partial?.welcomeBody ??
        'Thank you for your participation in this clinical study. Your contribution will help increase our understanding and help create treatments for people like you.',
      welcome_title: partial?.welcomeTitle ?? 'Welcome to Unify',
    },
    instructions: {
      app_name: partial?.appNameLabel ?? 'App name',
      title: partial?.appNameText ?? 'Unify Trials',
      sponsor_name: partial?.appSponsorText ?? 'AstraZeneca Pharmaceuticals',
      installation_instruction:
        partial?.patientInstruction ?? '1. Scan this QR code to download the app from the store.',
      login_instructions:
        partial?.patientInstallationInstruction ??
        '2. Install the app.\n3. Open app and click on “Log in” or “Log in with QR code”.\n4. Use login details provided or scan the QR code (valid for 7 days).',
    },
    login_details: {
      patient_login_details: partial?.patientLoginDetailsHeader ?? 'Your login details',
      temporary_password: partial?.temporaryPasswordLabel ?? 'Temporary password',
      temporary_password_valid_until_date: partial?.temporaryPasswordValidDateLabel ?? 'Temporary password valid until',
      username: partial?.usernameLabel ?? 'Username',
      scan_qr_code_label: partial?.scanCredentialsBody ?? 'Scan using your Unify app',
    },
    patient_web_instructions:
      partial?.patient_web_instructions ??
      'If you prefer to log in through the participant website, go to [${displayedUrl}](${url}). Please note that you need to activate your app account before being able to access the participant website. You may not be able to access some parts of the service on the website. If this happens, use the app.',
    support: {
      support_number: partial?.supportNumberLabel ?? 'Support number',
      title: partial?.supportDetailsHeader ?? 'Get support',
      details: partial?.supportDetailsBody ?? 'Contact your study site or your doctor or nurse for support.',
      patient_identifier: partial?.patientIdentfierLabel ?? 'Your patient code',
    },
  },
  uid: '[M]uid',
  _content_type_uid: 'anonymous_instructions',
});

export const AnonymousInstructionsContentModelMock = { create };
